export default {
    title: "Importaciones de Historial",
    startDateLabel: "Fecha inicial",
    endDateLabel: "Fecha final",
    startImportButton: "Iniciar importación",
    applyLabel: "Aplicar",
    cancelLabel: "Cancelar",
    startSuccessNotification: "Importación de historial iniciada con éxito",
    confirmTitle: "¿Estás seguro?",
    confirmPrefix: "Vas a",
    confirmHighlight: "cancelar esta importación de historial",
    confirmIrreversible: "Esta acción NO es reversible.",
    columnId: "ID",
    columnStartDate: "Fecha Inicial",
    columnEndDate: "Fecha Final",
    columnLastImportedDate: "Última Fecha Importada",
    columnStatus: "Estado",
    columnImportedDays: "Días importados",
    columnRemainingDays: "Días restantes",
    columnProgress: "Progreso",
    columnActions: "Acciones",
    noImportPerformed: "No se realizó ninguna importación",
    cancelButton: "Cancelar",
    cancelSuccessNotification: "Importación de Historial cancelada",
    cancelErrorNotification: "Error al cancelar la importación",
    statusComplete: "Completado",
    statusCancelled: "Cancelado",
    statusInProgress: "Procesando",
    statusPending: "Pendiente",
    statusFailed: "Falló",
    daySun: "Dom",
    dayMon: "Lun",
    dayTue: "Mar",
    dayWed: "Mié",
    dayThu: "Jue",
    dayFri: "Vie",
    daySat: "Sáb",
    monthJan: "Ene",
    monthFeb: "Feb",
    monthMar: "Mar",
    monthApr: "Abr",
    monthMay: "May",
    monthJun: "Jun",
    monthJul: "Jul",
    monthAug: "Ago",
    monthSep: "Sep",
    monthOct: "Oct",
    monthNov: "Nov",
    monthDec: "Dic",
};
